export enum BOOK_STATUS {
	DRAFT = 'DRAFT',
	TO_MODERATION = 'TO_MODERATION',
	TO_RELEASE = 'TO_RELEASE',
	ON_MODERATION = 'ON_MODERATION',
	REJECTED = 'REJECTED',
	APPROVED = 'APPROVED',
}